import { outcomes, treatments } from '../constants';

export function getTags(type: 't' | 'o', values: string[] = []) {
	const obj = type === 't' ? treatments : outcomes;
	return obj.filter((o) => values.includes(o.value));
}

export function merge(
	treatmentValues: string[],
	outcomeValues: string[],
	limit: boolean = false
) {
	const treatmentTags = getTags('t', treatmentValues);
	const outcomeTags = getTags('o', outcomeValues);

	if (limit) {
		const result: typeof treatmentTags = [];

		if (treatmentTags.length && outcomeTags.length) {
			// 1 from each
			result.push(outcomeTags[0], treatmentTags[0]);
		} else if (outcomeTags.length >= 2) {
			// 2 outcomes
			result.push(...outcomeTags.slice(0, 2));
		} else if (treatmentTags.length >= 2) {
			// 2 treatments
			result.push(...treatmentTags.slice(0, 2));
		} else {
			// fallback to any one or two items available
			result.push(...(outcomeTags.length ? outcomeTags.slice(0, 1) : []));
			result.push(...(treatmentTags.length ? treatmentTags.slice(0, 1) : []));
		}

		return result;
	}

	const result = [];

	result.push(...outcomeTags.slice(0, 2));

	result.push(...treatmentTags.slice(0, 2));

	if (result.length < 4) {
		const extraOutcomes = outcomeTags.slice(2);
		const extraTreatments = treatmentTags.slice(2);

		const extras = [...extraOutcomes, ...extraTreatments];
		const needed = 4 - result.length;

		result.push(...extras.slice(0, needed));
	}

	return result.slice(0, 4);
}
